import {useParams} from 'react-router-dom'
import styles from './RequestAbout.module.scss'
import {ProjectCard} from 'modules/project'
import {
  JournalRequestStatusPanel,
  JournalRequestDetails,
  JournalReview,
} from '..'
import {useGetJournalRequest} from '../api.journal'

export default function RequestAboutJournal() {
  const params = useParams()
  const {data: request, isRefetching} = useGetJournalRequest(params.uuid)

  const hasFCReview = !!request?.milestones?.map((x:any) => (x.type)).includes('financial-checked')
  return (
    <>
      <JournalRequestStatusPanel />
      <div className={styles.content}>
        <ProjectCard
          project={request.project}
          request={request}
          isRequestLoading={isRefetching}
          imgHeight={206}
        />
        <div>
          <div className={styles.grid}>
            <div className={styles.column}>
              <JournalRequestDetails />
            </div>
            <div className={styles.column}>
              { hasFCReview && 
                <JournalReview />
              }
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
